import { Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

// Components
import { isEmpty, slice } from 'lodash';
import { useParams } from 'react-router-dom';
import { StyledWhiteBox } from 'src/features/CompanyDetail/config';
import ReviewOverview from 'src/features/CompanyDetail/Reviews/ReviewOverview';
import SocialReview from 'src/features/CompanyDetail/Reviews/SocialReview';
import { v4 as uuidv4 } from 'uuid';
import ReviewItem, { ReviewItemLoading } from './ReviewItem';

// Utilities
// import DisclaimerAlert from 'src/components/common/DisclaimerAlert';
import { DefinedUseQueryResult } from '@tanstack/react-query';
import RelatedQuestion from 'src/features/CompanyDetail/Reviews/RelatedQuestion';
import { CommonResponseList } from 'src/model/common';
import { CompanyReviewDetail, CompanyReviews, CompanySocialReviews } from 'src/model/company';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { LIMIT_GET_LIST } from 'src/utils/constants/config';
import StyledPagination from 'src/components/common/StyledPagination';

const Review = ({
  review,
  socialReview,
  reviewRelatedQuestion,
  reviewDetail,
}: {
  review: DefinedUseQueryResult<CompanyReviews, Error>;
  socialReview: DefinedUseQueryResult<CompanySocialReviews, Error>;
  reviewRelatedQuestion: DefinedUseQueryResult<CommonResponseList, Error>;
  reviewDetail: DefinedUseQueryResult<CompanyReviewDetail, Error>;
}) => {
  const { id } = useParams();
  const [page, setPage] = useState(1);
  const [reviews, setReviews] = useState([] as ICompanyReview[]);

  const { data, isFetching } = review;
  const listAllReviews = getArrayDefault(data.data);

  useEffect(() => {
    const initialList = slice(listAllReviews, (page - 1) * LIMIT_GET_LIST, page * LIMIT_GET_LIST);
    setReviews(initialList);
  }, [page]);

  return (
    <React.Fragment>
      <Stack spacing={3}>
        <SocialReview socialReview={socialReview} id={id} />
        <StyledWhiteBox>
          <ReviewOverview reviewDetail={reviewDetail} id={id} />
        </StyledWhiteBox>

        {/* {!isEmpty(reviews) && (
          <DisclaimerAlert
            title="Reviews Do Not Reflect Our Views"
            content={
              <Typography variant="body1" align="left">
                The reviews on this page, including those from Google, Trustpilot, and user submissions, reflect
                individual opinions and do not represent the views of ADAMftd or its affiliates. We do not verify or
                endorse the accuracy of these reviews and take no responsibility for any actions taken based on them.{' '}
              </Typography>
            }
          />
        )} */}

        {!isEmpty(reviews) && (
          <StyledWhiteBox
            id="company-review-scrollable"
            display="flex"
            flexDirection="column"
            rowGap={3}
            // maxHeight={1200}
            overflow="auto"
          >
            <Typography variant="h5" align="left">
              All Reviews
            </Typography>

            <Stack gap={3}>
              {reviews.map((item) => (
                <ReviewItem key={uuidv4()} item={item} />
              ))}
              {isFetching && <ReviewItemLoading />}
            </Stack>
          </StyledWhiteBox>
        )}
        {!isEmpty(reviews) && (
          <Grid item xs={12}>
            <Stack justifyContent="center" alignItems="center">
              <StyledPagination
                page={page}
                total_pages={listAllReviews.length}
                onChange={function (_, value: number): void {
                  setPage(value);
                }}
              />
            </Stack>
          </Grid>
        )}

        <RelatedQuestion reviewRelatedQuestion={reviewRelatedQuestion} />
      </Stack>
    </React.Fragment>
  );
};

export default Review;
